import React from "react";
import { InlineMath } from "react-katex";
import {
  makeClosedTask,
  makeOptions,
  normalizeMay2026Variant,
  rationalLatex,
} from "../../../../matura/MaturaMay2026ClosedTaskSupport";
import { getLinearGraphData, renderLinearGraphContext, slopeLatex } from "./MaturaMay2026LinearGraphData";

const FIXED_OPTIONS = [
  ["A", "-\\frac{3}{2}"],
  ["B", "-\\frac{2}{3}"],
  ["C", "\\frac{2}{3}"],
  ["D", "\\frac{3}{2}"],
];

function makeWrongValues(slope) {
  return [-slope, 1 / slope, -1 / slope, 2, -2, 1, -1, 0]
    .filter((candidate, index, candidates) => (
      candidate !== slope && candidates.indexOf(candidate) === index
    ))
    .slice(0, 3)
    .map(rationalLatex);
}

function signed(number) {
  return number < 0 ? `(${number})` : String(number);
}

export function generateTask(options = {}) {
  const variant = normalizeMay2026Variant(options);
  const line = getLinearGraphData(variant === "original");
  const value = slopeLatex(line.a);
  const { options: taskOptions, correctIndex } = makeOptions(
    value,
    makeWrongValues(line.a),
    variant === "original" ? FIXED_OPTIONS : null
  );
  const xIntercept = -line.b / line.a;

  return makeClosedTask({
    type: "MaturaLinearSlopeFromGraphClosedTask",
    taskNumber: "13.2",
    variant,
    tags: ["funkcja liniowa", "wspolczynnik kierunkowy"],
    data: {
      ...line,
      kind: "linearGraph",
      showInterceptPoints: false,
      showSlopeAngle: true,
      context: renderLinearGraphContext({ includeAngle: true }),
      graphBeforeInstruction: true,
      instruction: "Dokończ zdanie. Wybierz właściwą odpowiedź spośród podanych.",
      prompt: <div style={{ display: "grid", gap: 8 }}>
        <span>Tangens kąta o mierze <InlineMath math={"\\alpha"} /> jest równy:</span>
      </div>,
      latex: null,
      options: taskOptions,
      correctIndex,
      explanationSteps: [
        {
          title: "Odczytujemy z wykresu punkty przecięcia prostej z osiami.",
          latex: `A=(${xIntercept},0),\\quad B=(0,${line.b})`,
        },
        {
          title: "Korzystamy ze wzoru na współczynnik kierunkowy prostej przechodzącej przez dwa punkty.",
          latex: "a=\\frac{y_B-y_A}{x_B-x_A}",
        },
        {
          title: "Podstawiamy współrzędne odczytanych punktów i obliczamy.",
          latex: `a=\\frac{${signed(line.b)}-0}{0-${signed(xIntercept)}}=${value}`,
        },
        {
          title: `Współczynnik kierunkowy jest tangensem ${line.a > 0 ? "ostrego" : "rozwartego"} kąta nachylenia prostej.`,
          latex: `\\tan\\alpha=a=${value}`,
        },
      ],
    },
  });
}

export { checkClosedAnswer as checkAnswer, renderClosedAnswer as renderAnswer, renderClosedExplanation as renderExplanation, renderClosedInput as renderInput, renderClosedTask as renderTask, renderClosedUserAnswer as renderUserAnswer } from "../../../../matura/MaturaMay2026ClosedTaskSupport";
